/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
// import { authSlice } from "../../../../../Store/modules/AuthModule/authSlice";
import { authSlice } from "../../../Store/modules/AuthModule/authSlice";
import { Link } from "react-router-dom";
import ChangePasswordModal from "../../../components/ChangePasswordModal";
import OrgLogoUploadModal from "../../../components/OrgLogoUploadModal";

const { actions } = authSlice;
export function DropdownMenu4() {
  const dispatch = useDispatch();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showOrgLogo, setShowOrgLogo] = useState(false);

  function logout() {
    dispatch(actions.logout());
  }

  return (
    <>
      {/*begin::Navigation*/}
      <ul className="navi navi-hover py-5">
        <li className="navi-item">
          <Link to="/" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">dashboard</i>
            </span>
            <span className="navi-text">Dashboard</span>
          </Link>
        </li>
        <li className="navi-item">
          <a href="#" onClick={() => setShowChangePassword(true)} className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">lock</i>
            </span>
            <span className="navi-text">Change Password</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" onClick={() => setShowOrgLogo(true)} className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">business</i>
            </span>
            <span className="navi-text">Organization Logo</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" onClick={logout} className="navi-link">
            <span className="navi-icon">
              <i className="flaticon-logout"></i>
            </span>
            <span className="navi-text">Logout</span>
            <span className="navi-link-badge"></span>
          </a>
        </li>
      </ul>

      <ChangePasswordModal
        show={showChangePassword}
        handleClose={() => setShowChangePassword(false)}
      />
      <OrgLogoUploadModal
        open={showOrgLogo}
        onClose={() => setShowOrgLogo(false)}
      />

      {/*end::Navigation*/}
      {/*
      <ul className="navi navi-hover py-5">
        <li className="navi-item">
          <a href={process.env.REACT_APP_LOGIN_URL} className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">dashboard</i>
            </span>
            <span className="navi-text">Dashboard</span>
          </a>
        </li>
      
       <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">create</i>
            </span>
            <span className="navi-text">Edit</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">system_update_alt</i>
            </span>
            <span className="navi-text">Download</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">backup</i>
            </span>
            <span className="navi-text">Export to word</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">email</i>
            </span>
            <span className="navi-text">Send to email</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">share</i>
            </span>
            <span className="navi-text">Share</span>
          </a>
        </li> 

       <li className="navi-separator my-3"></li> 

       <li className="navi-item">
          <a href="#" className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">content_copy</i>
            </span>
            <span className="navi-text">Duplicate</span>
          </a>
        </li>
        <li className="navi-item">
          <a href="#" onClick={logout} className="navi-link">
            <span className="navi-icon">
              <i className="material-icons">delete</i>
            </span>
            <span className="navi-text">Delete</span>
          </a>
        </li>
      </ul>
       */}
    </>
  );
}
